import { LogicalWidgetEventStruct } from "../logical-widget-event.struct";
import { AlertWidgetEnum } from "../../../../enums";

export class LogicalAlertWidgetEventStruct extends LogicalWidgetEventStruct {
  public event_alert_widget_type: AlertWidgetEnum;
}
